import React from "react";

function PrivacyPolicy() {
  const APP_NAME = "PSH"; // 🔴 CHANGE
  const COMPANY_NAME = "PSH"; // 🔴 CHANGE
  const CONTACT_EMAIL = "admin@powerservicehub.com"; // 🔴 CHANGE
  const EFFECTIVE_DATE = "20 February 2026";

  return (
    <div className="min-h-screen bg-white text-gray-800 px-6 py-10 max-w-3xl mx-auto">
      <h1 className="text-3xl font-bold text-[#307CF8] mb-4">
        Privacy Policy
      </h1>

      <p className="text-sm text-gray-500 mb-6">
        Effective Date: {EFFECTIVE_DATE}
      </p>

      <p className="mb-4">
        {COMPANY_NAME} ("we", "our", or "us") operates the {APP_NAME}
        shopping application. This Privacy Policy explains how we collect,
        use, disclose, and safeguard your information when you use our
        service.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">
        1. Information We Collect
      </h2>
      <ul className="list-disc pl-6 mb-4 space-y-1">
        <li>Full name</li>
        <li>Email address</li>
        <li>Phone number</li>
        <li>Order and transaction information</li>
      </ul>

      <h2 className="text-xl font-semibold mt-6 mb-2">
        2. How We Use Your Information
      </h2>
      <ul className="list-disc pl-6 mb-4 space-y-1">
        <li>To create and manage your account</li>
        <li>To process orders and payments</li>
        <li>To communicate order updates</li>
        <li>To improve our services</li>
        <li>To comply with legal obligations</li>
      </ul>

      <h2 className="text-xl font-semibold mt-6 mb-2">
        3. Payment Processing
      </h2>
      <p className="mb-4">
        We use <strong>Interswitch</strong> as our secure third-party payment
        gateway. When you make a payment, your payment details are processed
        directly by Interswitch. We do not store your full card or banking
        information on our servers.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">
        4. Sharing Your Information
      </h2>
      <p className="mb-4">
        We do not sell your personal data. We may share information with:
      </p>
      <ul className="list-disc pl-6 mb-4 space-y-1">
        <li>Payment processors (e.g., Interswitch)</li>
        <li>Logistics and delivery partners</li>
        <li>Service providers who support our platform</li>
        <li>Authorities when required by law</li>
      </ul>

      <h2 className="text-xl font-semibold mt-6 mb-2">
        5. Data Security
      </h2>
      <p className="mb-4">
        We implement appropriate technical and organizational security
        measures to protect your information. However, no electronic
        transmission is completely secure.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">
        6. Data Retention
      </h2>
      <p className="mb-4">
        We retain personal information only for as long as necessary to
        provide our services and meet legal requirements.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">
        7. Your Rights
      </h2>
      <p className="mb-4">
        You may request access, correction, or deletion of your personal
        data by contacting us.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">
        8. Children's Privacy
      </h2>
      <p className="mb-4">
        Our services are not intended for children under 13 years of age.
        We do not knowingly collect data from children.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">
        9. Changes to This Privacy Policy
      </h2>
      <p className="mb-4">
        We may update this policy periodically. Updates will be posted on
        this page with a revised effective date.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">
        10. Contact Us
      </h2>
      <p className="mb-4">
        If you have questions about this Privacy Policy, contact us at:
      </p>
      <p className="font-medium">{CONTACT_EMAIL}</p>
    </div>
  );
}

export default PrivacyPolicy;